"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualMotorMtaPremiumWordingGenerator = void 0;
var React = require("react");
var services_1 = require("@falcon/services");
var commonFunctions_1 = require("../../../commonFunctions");
var MtaPremiumWording_1 = require("./MtaPremiumWording");
var AnnualMotorMtaPremiumWordingGenerator = exports.AnnualMotorMtaPremiumWordingGenerator = /** @class */ (function () {
    function AnnualMotorMtaPremiumWordingGenerator() {
    }
    AnnualMotorMtaPremiumWordingGenerator.generateMtaPremiumWording = function (interaction, policies, price, showSummaryPageWording) {
        if (policies && policies.length > 0) {
            var previousPolicyInteraction = AnnualMotorMtaPremiumWordingGenerator.findPreviousPolicyInteraction(policies, interaction);
            var addonsOrExcessesChanged = AnnualMotorMtaPremiumWordingGenerator.getAddonsOrExcessesChanged(previousPolicyInteraction, interaction);
            var additionalQuestionsChanged = AnnualMotorMtaPremiumWordingGenerator.getAdditionalQuestionsChangedCount(previousPolicyInteraction, interaction);
            var carsInHouseholdNotChanged = interaction.policyHolder.carsInHousehold === previousPolicyInteraction.policyHolder.carsInHousehold;
            var isAdditionalDriverEdited = AnnualMotorMtaPremiumWordingGenerator.isAdditionalDriverEdited(previousPolicyInteraction, interaction);
            var totalFieldsChanged = addonsOrExcessesChanged.length + additionalQuestionsChanged;
            var singleChangeWasMade = totalFieldsChanged === 1 && addonsOrExcessesChanged.length === 1 && !isAdditionalDriverEdited && carsInHouseholdNotChanged;
            var tierChangeWording = (0, commonFunctions_1.getTierChangeWording)(interaction);
            var isRefund = interaction.factors.returnPremium > 0;
            if (singleChangeWasMade) {
                return AnnualMotorMtaPremiumWordingGenerator.wordingForSingleAddonOrExcessChange(addonsOrExcessesChanged[0].key, addonsOrExcessesChanged[0].state, interaction.vehicles[0], tierChangeWording, price);
            }
            else {
                return AnnualMotorMtaPremiumWordingGenerator.wordingForAnyOtherChangesMade(isRefund, tierChangeWording, price, showSummaryPageWording);
            }
        }
        else {
            return new MtaPremiumWording_1.MtaPremiumWording("", "", true);
        }
    };
    AnnualMotorMtaPremiumWordingGenerator.findPreviousPolicyInteraction = function (policies, interaction) {
        var previousPolicies = [];
        if (policies && policies.length > 0) {
            policies.forEach(function (policy) {
                if (policy.status !== services_1.POLICY_STATUS_MTC && policy.interaction.vehicles && policy.policyNumber === interaction.agreementNumber) {
                    previousPolicies.push(policy);
                }
            });
        }
        return previousPolicies.length > 0 ? previousPolicies[0].interaction : previousPolicies;
    };
    AnnualMotorMtaPremiumWordingGenerator.getAddonsOrExcessesChanged = function (previousPolicyInteraction, interaction) {
        var previousOptionalExtras = previousPolicyInteraction.optionalExtras;
        var optionalExtras = interaction.optionalExtras;
        var interactionAddonsAndExcesses = [
            { key: "familyPackage", state: optionalExtras.familyPackage },
            { key: "breakdownCover", state: optionalExtras.breakdownCoverLevel },
            { key: "doNotDisclose", state: interaction.policyHolder.ncd.doNotDisclose }
        ];
        var policyAddonsAndExcesses = [
            { key: "familyPackage", state: previousOptionalExtras.familyPackage },
            { key: "breakdownCover", state: previousOptionalExtras.breakdownCoverLevel },
            { key: "doNotDisclose", state: previousPolicyInteraction.policyHolder.ncd.doNotDisclose }
        ];
        var results = [];
        interactionAddonsAndExcesses.forEach(function (i) {
            var differentValue = policyAddonsAndExcesses.find(function (policy) {
                return (policy.key === i.key) && (policy.state != i.state);
            });
            if (differentValue) {
                results.push(i);
            }
        });
        return results;
    };
    AnnualMotorMtaPremiumWordingGenerator.getAdditionalQuestionsChangedCount = function (policyInteraction, interaction) {
        var interactionVehicle = interaction.vehicles[0];
        var policyInteractionVehicle = policyInteraction.vehicles[0];
        var objectCarInteraction = [
            { key: "purchaseDate", value: interactionVehicle.purchaseDate },
            { key: "mileage", value: interactionVehicle.mileage },
            { key: "overnightLocationIsHome", value: interactionVehicle.overnightLocationIsHome },
            { key: "hasModifications", value: interactionVehicle.hasModifications }
        ];
        var objectCarPolicyInteraction = [
            { key: "purchaseDate", value: policyInteractionVehicle.purchaseDate },
            { key: "mileage", value: policyInteractionVehicle.mileage },
            { key: "overnightLocationIsHome", value: policyInteractionVehicle.overnightLocationIsHome },
            { key: "hasModifications", value: policyInteractionVehicle.hasModifications }
        ];
        var results = [];
        objectCarInteraction.forEach(function (interactionCar) {
            var differentValue = objectCarPolicyInteraction.find(function (policyInteraction) {
                return (interactionCar.key === policyInteraction.key) && (interactionCar.value !== policyInteraction.value);
            });
            if (differentValue) {
                results.push(policyInteraction);
            }
        });
        return results.length;
    };
    AnnualMotorMtaPremiumWordingGenerator.getDriverFieldsChangedCount = function (interactionPersons, policyInteractionPersons) {
        var difference = Object.keys(interactionPersons).filter(function (key) {
            if (key === "numberOfReadOnlyClaims" || key === "numberOfReadOnlyConviction" || key === "driverInfoEdited") {
                return;
            }
            else {
                return interactionPersons[key] !== policyInteractionPersons[key];
            }
        });
        return difference.length;
    };
    AnnualMotorMtaPremiumWordingGenerator.isAdditionalDriverEdited = function (policyInteraction, interaction) {
        var result = false;
        if ((policyInteraction.additionalDrivers && interaction.additionalDrivers) && (policyInteraction.additionalDrivers.length === interaction.additionalDrivers.length)) {
            var policyInteractionAdditionalDrivers_1 = AnnualMotorMtaPremiumWordingGenerator.flattenAdditionalDriversObject(policyInteraction.additionalDrivers);
            var interactionAdditionalDrivers_1 = AnnualMotorMtaPremiumWordingGenerator.flattenAdditionalDriversObject(interaction.additionalDrivers);
            var fieldsChanged_1 = 0;
            interactionAdditionalDrivers_1.forEach(function (driver, index) {
                fieldsChanged_1 += AnnualMotorMtaPremiumWordingGenerator.getDriverFieldsChangedCount(interactionAdditionalDrivers_1[index], policyInteractionAdditionalDrivers_1[index]);
            });
            result = fieldsChanged_1 > 0;
        }
        if (policyInteraction.additionalDrivers && !interaction.additionalDrivers) {
            result = false;
        }
        return result;
    };
    AnnualMotorMtaPremiumWordingGenerator.wordingForSingleAddonOrExcessChange = function (changedItemId, addedOrRemoved, vehicle, tierChangeWording, price) {
        var optionalExtrasMapping = [
            { key: "familyPackage", value: "Family package" },
            { key: "breakdownCover", value: "Breakdown cover" },
            { key: "doNotDisclose", value: "Protected no claim discount" }
        ];
        var wordingToShow = optionalExtrasMapping.find(function (wording) { return wording.key === changedItemId; });
        var mtaDetailsWording = "for ".concat(addedOrRemoved ? "adding" : "removing", " ").concat(wordingToShow.value, " add-on to ").concat(vehicle.make, ", ").concat(vehicle.model, " (").concat(vehicle.registrationNumber, ")");
        var wordingForPaymentReason = "".concat(addedOrRemoved ? "add" : "remove", " ").concat(wordingToShow.value);
        var prefix = !addedOrRemoved ? "from" : "to";
        return new MtaPremiumWording_1.MtaPremiumWording((React.createElement("div", null,
            React.createElement("p", { className: "font-weight-semi-bold pt-2 mb-0" }, "".concat(price !== null && price !== void 0 ? price : '', " to ").concat(wordingForPaymentReason, " ").concat(prefix, " ").concat(vehicle.make, ", ").concat(vehicle.model, " (").concat(vehicle.registrationNumber, ")"),
                " ",
                tierChangeWording))), mtaDetailsWording, false);
    };
    AnnualMotorMtaPremiumWordingGenerator.wordingForAnyOtherChangesMade = function (isRefund, tierChangeWording, price, showSummaryPageWording) {
        var renderTierChangeWording = tierChangeWording.trim() !== "";
        return new MtaPremiumWording_1.MtaPremiumWording((React.createElement(React.Fragment, null,
            showSummaryPageWording && React.createElement("div", null, isRefund ? "You'll receive a refund of ".concat(price, " for making this change.")
                : "You'll pay an additional ".concat(price, " for your changes to cover you from the start date selected to the end of your policy.")),
            renderTierChangeWording && React.createElement("div", null,
                React.createElement("p", { className: "font-weight-semi-bold pt-2 mb-0" }, price !== null && price !== void 0 ? price : '',
                    " ",
                    isRefund ? "refund " : "",
                    "for the changes you have made"),
                " ",
                tierChangeWording))), "genericMessage", true);
    };
    AnnualMotorMtaPremiumWordingGenerator.flattenAdditionalDriversObject = function (additionalDriverObject) {
        var resultArray = [];
        additionalDriverObject.forEach(function (driver) {
            var flattenedDriverObject = (0, commonFunctions_1.flattenObjectJson)(driver);
            resultArray.push(flattenedDriverObject);
        });
        return resultArray;
    };
    return AnnualMotorMtaPremiumWordingGenerator;
}());
//# sourceMappingURL=AnnualMotorMtaPremiumWordingGenerator.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/helpers/annual/motor/AnnualMotorMtaPremiumWordingGenerator.js
// module id = 1244
// module chunks = 0